/**
 * Feature setting for sending ticket creation PETE events entirely from BE
 */
export const HELP_CENTER_TICKET_PETE_EVENTS_FROM_BE_241015 =
  'HELP_CENTER_TICKET_PETE_EVENTS_FROM_BE_241015';
